// AUTO-GENERATED by scripts/tag_careers.py - do not edit manually.
// 7-trait weights (0-100) + constraint metadata for the v2 matching engine.

export type RejectionTag = 'healthcare' | 'manual' | 'desk' | 'sales' | 'numbers' | 'creative';

export interface CareerMeta {
  analytical: number;
  creative: number;
  social: number;
  physical: number;
  structure: number;
  risk: number;
  income: number;
  studyYears: number;
  riskLevel: 'low' | 'medium' | 'high';
  pressureLevel: 'low' | 'medium' | 'high';
  rejectionTags: RejectionTag[];
}

export const CAREER_META: Record<string, CareerMeta> = {
  "AI / Machine Learning Engineer": {
    analytical: 90, creative: 60, social: 30, physical: 10,
    structure: 60, risk: 50, income: 90,
    studyYears: 3.5, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['desk', 'numbers'],
  },
  "Accountant": {
    analytical: 90, creative: 20, social: 40, physical: 10,
    structure: 90, risk: 30, income: 70,
    studyYears: 4, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['numbers', 'desk'],
  },
  "Architect": {
    analytical: 70, creative: 80, social: 60, physical: 30,
    structure: 80, risk: 60, income: 70,
    studyYears: 7, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['desk', 'creative'],
  },
  "Bartender": {
    analytical: 30, creative: 50, social: 80, physical: 60,
    structure: 50, risk: 40, income: 30,
    studyYears: 0.25, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
  "Beautician": {
    analytical: 20, creative: 60, social: 80, physical: 50,
    structure: 40, risk: 50, income: 40,
    studyYears: 1.5, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['manual', 'creative'],
  },
  "Brand Manager": {
    analytical: 65, creative: 70, social: 70, physical: 10,
    structure: 40, risk: 50, income: 75,
    studyYears: 3, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['desk', 'creative'],
  },
  "Care Worker": {
    analytical: 30, creative: 20, social: 90, physical: 60,
    structure: 70, risk: 20, income: 30,
    studyYears: 0.25, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['healthcare', 'manual'],
  },
  "Carpenter": {
    analytical: 50, creative: 60, social: 40, physical: 70,
    structure: 60, risk: 30, income: 50,
    studyYears: 3, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
  "Chef": {
    analytical: 40, creative: 70, social: 40, physical: 80,
    structure: 70, risk: 60, income: 40,
    studyYears: 1, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: [],
  },
  "Civil Engineer": {
    analytical: 80, creative: 50, social: 60, physical: 40,
    structure: 80, risk: 40, income: 70,
    studyYears: 6, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['numbers', 'desk'],
  },
  "Civil Engineering Technician": {
    analytical: 70, creative: 30, social: 40, physical: 50,
    structure: 70, risk: 30, income: 50,
    studyYears: 2, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: [],
  },
  "Civil Servant (Generalist)": {
    analytical: 60, creative: 30, social: 70, physical: 20,
    structure: 80, risk: 20, income: 50,
    studyYears: 3, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['desk'],
  },
  "Civil Service Officer": {
    analytical: 70, creative: 40, social: 60, physical: 20,
    structure: 70, risk: 20, income: 50,
    studyYears: 1, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['desk'],
  },
  "Cleaner": {
    analytical: 10, creative: 5, social: 15, physical: 80,
    structure: 70, risk: 20, income: 20,
    studyYears: 0, riskLevel: 'low', pressureLevel: 'low',
    rejectionTags: ['manual'],
  },
  "Construction Worker": {
    analytical: 40, creative: 20, social: 30, physical: 90,
    structure: 80, risk: 60, income: 50,
    studyYears: 0.5, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
  "Content Creator": {
    analytical: 40, creative: 95, social: 70, physical: 15,
    structure: 15, risk: 90, income: 70,
    studyYears: 0, riskLevel: 'high', pressureLevel: 'high',
    rejectionTags: ['creative'],
  },
  "Counsellor": {
    analytical: 60, creative: 40, social: 90, physical: 20,
    structure: 50, risk: 50, income: 50,
    studyYears: 4, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['healthcare', 'desk'],
  },
  "Customer Service Advisor": {
    analytical: 30, creative: 20, social: 85, physical: 10,
    structure: 80, risk: 30, income: 35,
    studyYears: 0.25, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['desk'],
  },
  "Cybersecurity Analyst": {
    analytical: 90, creative: 40, social: 30, physical: 10,
    structure: 70, risk: 40, income: 75,
    studyYears: 2, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['desk', 'numbers'],
  },
  "Data Analyst": {
    analytical: 85, creative: 20, social: 40, physical: 10,
    structure: 70, risk: 40, income: 70,
    studyYears: 1.5, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['desk', 'numbers'],
  },
  "Delivery Driver": {
    analytical: 30, creative: 5, social: 40, physical: 60,
    structure: 60, risk: 30, income: 30,
    studyYears: 0.1, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
  "Dental Nurse": {
    analytical: 50, creative: 30, social: 80, physical: 40,
    structure: 90, risk: 30, income: 40,
    studyYears: 1.5, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['healthcare', 'desk'],
  },
  "Doctor (GP)": {
    analytical: 80, creative: 50, social: 90, physical: 60,
    structure: 80, risk: 30, income: 90,
    studyYears: 10, riskLevel: 'low', pressureLevel: 'high',
    rejectionTags: ['healthcare'],
  },
  "Electrical Engineer": {
    analytical: 85, creative: 45, social: 35, physical: 55,
    structure: 75, risk: 30, income: 65,
    studyYears: 4, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['desk'],
  },
  "Electrician": {
    analytical: 70, creative: 30, social: 40, physical: 80,
    structure: 70, risk: 30, income: 70,
    studyYears: 3.5, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
  "Environmental Scientist": {
    analytical: 80, creative: 50, social: 50, physical: 40,
    structure: 50, risk: 40, income: 70,
    studyYears: 3, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['desk', 'numbers'],
  },
  "Estate Agent": {
    analytical: 40, creative: 50, social: 90, physical: 30,
    structure: 60, risk: 80, income: 70,
    studyYears: 0.5, riskLevel: 'high', pressureLevel: 'high',
    rejectionTags: ['sales'],
  },
  "Facilities Manager": {
    analytical: 70, creative: 40, social: 70, physical: 50,
    structure: 80, risk: 50, income: 70,
    studyYears: 4.5, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['desk'],
  },
  "Factory Operative": {
    analytical: 30, creative: 5, social: 20, physical: 70,
    structure: 80, risk: 30, income: 30,
    studyYears: 0.1, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
  "Farmer": {
    analytical: 60, creative: 20, social: 30, physical: 90,
    structure: 50, risk: 80, income: 50,
    studyYears: 3, riskLevel: 'high', pressureLevel: 'high',
    rejectionTags: ['manual'],
  },
  "Financial Analyst": {
    analytical: 90, creative: 20, social: 50, physical: 20,
    structure: 70, risk: 50, income: 80,
    studyYears: 1, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['desk', 'numbers'],
  },
  "Firefighter": {
    analytical: 60, creative: 20, social: 80, physical: 90,
    structure: 80, risk: 80, income: 60,
    studyYears: 1, riskLevel: 'high', pressureLevel: 'high',
    rejectionTags: ['manual'],
  },
  "Forestry Worker": {
    analytical: 40, creative: 20, social: 30, physical: 85,
    structure: 70, risk: 50, income: 40,
    studyYears: 1, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
  "Founder / Entrepreneur": {
    analytical: 70, creative: 90, social: 80, physical: 20,
    structure: 10, risk: 100, income: 90,
    studyYears: 0, riskLevel: 'high', pressureLevel: 'high',
    rejectionTags: ['sales'],
  },
  "Freelancer": {
    analytical: 50, creative: 70, social: 60, physical: 20,
    structure: 20, risk: 80, income: 60,
    studyYears: 0, riskLevel: 'high', pressureLevel: 'high',
    rejectionTags: ['desk', 'sales'],
  },
  "Gardener / Landscaper": {
    analytical: 30, creative: 70, social: 50, physical: 80,
    structure: 60, risk: 60, income: 50,
    studyYears: 1, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['manual', 'creative'],
  },
  "Graphic Designer": {
    analytical: 30, creative: 90, social: 50, physical: 10,
    structure: 40, risk: 50, income: 50,
    studyYears: 2, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['desk', 'creative'],
  },
  "HGV Driver": {
    analytical: 40, creative: 5, social: 30, physical: 60,
    structure: 80, risk: 20, income: 40,
    studyYears: 0.5, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
  "HR Business Partner": {
    analytical: 50, creative: 20, social: 80, physical: 10,
    structure: 50, risk: 40, income: 70,
    studyYears: 5, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['desk'],
  },
  "Hairdresser": {
    analytical: 30, creative: 70, social: 80, physical: 60,
    structure: 40, risk: 50, income: 40,
    studyYears: 2.5, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['manual', 'creative'],
  },
  "Healthcare Assistant": {
    analytical: 40, creative: 20, social: 90, physical: 70,
    structure: 80, risk: 30, income: 30,
    studyYears: 0.5, riskLevel: 'low', pressureLevel: 'high',
    rejectionTags: ['healthcare', 'manual'],
  },
  "Heating and Gas Engineer": {
    analytical: 70, creative: 30, social: 60, physical: 80,
    structure: 70, risk: 40, income: 70,
    studyYears: 3, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
  "Hotel Manager": {
    analytical: 70, creative: 50, social: 80, physical: 40,
    structure: 70, risk: 50, income: 60,
    studyYears: 5, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['desk', 'sales'],
  },
  "IT Support Technician": {
    analytical: 60, creative: 20, social: 60, physical: 30,
    structure: 70, risk: 20, income: 40,
    studyYears: 1, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['desk'],
  },
  "Journalist": {
    analytical: 60, creative: 70, social: 70, physical: 30,
    structure: 30, risk: 60, income: 45,
    studyYears: 2, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['creative'],
  },
  "Lab Scientist": {
    analytical: 90, creative: 40, social: 30, physical: 30,
    structure: 80, risk: 30, income: 60,
    studyYears: 4, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['desk'],
  },
  "Lab Technician": {
    analytical: 70, creative: 20, social: 20, physical: 40,
    structure: 85, risk: 25, income: 45,
    studyYears: 1, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: [],
  },
  "Laboratory Technician": {
    analytical: 70, creative: 20, social: 30, physical: 40,
    structure: 80, risk: 30, income: 40,
    studyYears: 1.5, riskLevel: 'low', pressureLevel: 'low',
    rejectionTags: ['desk'],
  },
  "Landscaper / Gardener": {
    analytical: 20, creative: 50, social: 40, physical: 85,
    structure: 50, risk: 30, income: 35,
    studyYears: 1, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['manual', 'creative'],
  },
  "Lecturer": {
    analytical: 90, creative: 80, social: 70, physical: 20,
    structure: 40, risk: 60, income: 70,
    studyYears: 7, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['desk', 'creative'],
  },
  "Logistics Coordinator": {
    analytical: 60, creative: 10, social: 40, physical: 30,
    structure: 70, risk: 30, income: 50,
    studyYears: 1, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['desk'],
  },
  "Maintenance Engineer": {
    analytical: 75, creative: 50, social: 30, physical: 80,
    structure: 70, risk: 40, income: 60,
    studyYears: 3, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
  "Management Consultant": {
    analytical: 90, creative: 60, social: 80, physical: 10,
    structure: 60, risk: 70, income: 90,
    studyYears: 3, riskLevel: 'high', pressureLevel: 'high',
    rejectionTags: ['desk', 'numbers'],
  },
  "Marketing Executive": {
    analytical: 50, creative: 60, social: 70, physical: 10,
    structure: 40, risk: 40, income: 60,
    studyYears: 2, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['desk', 'sales'],
  },
  "Mechanic": {
    analytical: 80, creative: 30, social: 40, physical: 80,
    structure: 70, risk: 30, income: 60,
    studyYears: 3, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
  "Mechanical Engineer": {
    analytical: 80, creative: 50, social: 40, physical: 50,
    structure: 70, risk: 30, income: 60,
    studyYears: 4, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['desk'],
  },
  "Nurse": {
    analytical: 70, creative: 40, social: 90, physical: 70,
    structure: 80, risk: 30, income: 50,
    studyYears: 3, riskLevel: 'low', pressureLevel: 'high',
    rejectionTags: ['healthcare'],
  },
  "Operations Manager": {
    analytical: 70, creative: 30, social: 60, physical: 40,
    structure: 60, risk: 50, income: 75,
    studyYears: 5, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['desk'],
  },
  "PR Officer": {
    analytical: 50, creative: 60, social: 80, physical: 10,
    structure: 50, risk: 40, income: 55,
    studyYears: 1, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['desk', 'creative'],
  },
  "Paralegal": {
    analytical: 70, creative: 20, social: 50, physical: 20,
    structure: 80, risk: 20, income: 40,
    studyYears: 0.5, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['desk'],
  },
  "Paramedic": {
    analytical: 80, creative: 30, social: 90, physical: 80,
    structure: 80, risk: 80, income: 60,
    studyYears: 3, riskLevel: 'high', pressureLevel: 'high',
    rejectionTags: ['healthcare', 'manual'],
  },
  "Pastry Chef": {
    analytical: 40, creative: 80, social: 30, physical: 70,
    structure: 70, risk: 40, income: 30,
    studyYears: 3, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['manual', 'creative'],
  },
  "Personal Trainer": {
    analytical: 30, creative: 50, social: 80, physical: 70,
    structure: 40, risk: 60, income: 50,
    studyYears: 0.5, riskLevel: 'high', pressureLevel: 'medium',
    rejectionTags: ['manual', 'sales'],
  },
  "Pharmacist": {
    analytical: 80, creative: 20, social: 70, physical: 30,
    structure: 90, risk: 20, income: 70,
    studyYears: 5, riskLevel: 'low', pressureLevel: 'high',
    rejectionTags: ['healthcare', 'desk'],
  },
  "Physiotherapist": {
    analytical: 80, creative: 20, social: 70, physical: 60,
    structure: 60, risk: 30, income: 60,
    studyYears: 3.5, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['healthcare'],
  },
  "Pilot": {
    analytical: 80, creative: 10, social: 50, physical: 60,
    structure: 90, risk: 70, income: 90,
    studyYears: 3, riskLevel: 'high', pressureLevel: 'high',
    rejectionTags: ['desk'],
  },
  "Plumber": {
    analytical: 60, creative: 20, social: 40, physical: 90,
    structure: 70, risk: 30, income: 70,
    studyYears: 3, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
  "Police Officer": {
    analytical: 70, creative: 30, social: 80, physical: 70,
    structure: 80, risk: 70, income: 60,
    studyYears: 2.5, riskLevel: 'high', pressureLevel: 'high',
    rejectionTags: [],
  },
  "Prison Officer": {
    analytical: 40, creative: 20, social: 80, physical: 70,
    structure: 90, risk: 60, income: 30,
    studyYears: 0.5, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['manual'],
  },
  "Product Manager": {
    analytical: 75, creative: 75, social: 80, physical: 10,
    structure: 60, risk: 50, income: 90,
    studyYears: 4, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['desk'],
  },
  "Professional Footballer": {
    analytical: 30, creative: 70, social: 70, physical: 95,
    structure: 80, risk: 90, income: 95,
    studyYears: 10, riskLevel: 'high', pressureLevel: 'high',
    rejectionTags: [],
  },
  "Project Manager": {
    analytical: 70, creative: 40, social: 75, physical: 20,
    structure: 70, risk: 50, income: 70,
    studyYears: 3, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['desk'],
  },
  "Quantity Surveyor": {
    analytical: 80, creative: 30, social: 50, physical: 30,
    structure: 80, risk: 40, income: 70,
    studyYears: 4, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['numbers', 'desk'],
  },
  "Recruiter": {
    analytical: 40, creative: 50, social: 90, physical: 10,
    structure: 60, risk: 70, income: 60,
    studyYears: 0.5, riskLevel: 'high', pressureLevel: 'high',
    rejectionTags: ['desk', 'sales'],
  },
  "Research Scientist": {
    analytical: 95, creative: 70, social: 40, physical: 30,
    structure: 40, risk: 70, income: 90,
    studyYears: 7, riskLevel: 'high', pressureLevel: 'high',
    rejectionTags: ['desk', 'numbers'],
  },
  "Retail Store Manager": {
    analytical: 60, creative: 40, social: 70, physical: 50,
    structure: 70, risk: 40, income: 50,
    studyYears: 2.5, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['desk', 'sales'],
  },
  "SEO Specialist": {
    analytical: 70, creative: 60, social: 50, physical: 10,
    structure: 50, risk: 50, income: 50,
    studyYears: 1.5, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['desk', 'creative'],
  },
  "Sales Executive": {
    analytical: 40, creative: 50, social: 90, physical: 30,
    structure: 40, risk: 70, income: 80,
    studyYears: 0.5, riskLevel: 'high', pressureLevel: 'high',
    rejectionTags: ['sales'],
  },
  "Scaffolder": {
    analytical: 40, creative: 20, social: 40, physical: 90,
    structure: 80, risk: 50, income: 50,
    studyYears: 2, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
  "Site Manager": {
    analytical: 70, creative: 40, social: 70, physical: 60,
    structure: 80, risk: 60, income: 70,
    studyYears: 4.5, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['manual'],
  },
  "Social Media Manager": {
    analytical: 40, creative: 80, social: 75, physical: 10,
    structure: 30, risk: 40, income: 50,
    studyYears: 1, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['desk', 'creative'],
  },
  "Social Worker": {
    analytical: 60, creative: 40, social: 90, physical: 30,
    structure: 70, risk: 40, income: 40,
    studyYears: 4, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['healthcare', 'desk'],
  },
  "Software Engineer": {
    analytical: 85, creative: 70, social: 40, physical: 10,
    structure: 70, risk: 40, income: 80,
    studyYears: 4, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['desk'],
  },
  "Solicitor": {
    analytical: 90, creative: 50, social: 70, physical: 20,
    structure: 80, risk: 50, income: 90,
    studyYears: 6, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['desk'],
  },
  "Sports Coach": {
    analytical: 60, creative: 80, social: 90, physical: 70,
    structure: 50, risk: 60, income: 50,
    studyYears: 2, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['sales'],
  },
  "Sports Massage Therapist": {
    analytical: 50, creative: 30, social: 70, physical: 80,
    structure: 50, risk: 60, income: 40,
    studyYears: 0.75, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['healthcare', 'manual'],
  },
  "Sports Therapist": {
    analytical: 70, creative: 40, social: 85, physical: 60,
    structure: 70, risk: 40, income: 60,
    studyYears: 4, riskLevel: 'low', pressureLevel: 'high',
    rejectionTags: ['healthcare'],
  },
  "Teacher": {
    analytical: 60, creative: 70, social: 90, physical: 50,
    structure: 70, risk: 20, income: 50,
    studyYears: 3, riskLevel: 'low', pressureLevel: 'high',
    rejectionTags: [],
  },
  "Teaching Assistant": {
    analytical: 30, creative: 50, social: 80, physical: 40,
    structure: 60, risk: 20, income: 20,
    studyYears: 0.5, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['healthcare'],
  },
  "Train Driver": {
    analytical: 40, creative: 5, social: 10, physical: 60,
    structure: 80, risk: 40, income: 60,
    studyYears: 1.5, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['manual'],
  },
  "UX Designer": {
    analytical: 60, creative: 80, social: 70, physical: 10,
    structure: 50, risk: 40, income: 70,
    studyYears: 2, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['desk', 'creative'],
  },
  "UX Researcher": {
    analytical: 70, creative: 70, social: 80, physical: 10,
    structure: 50, risk: 50, income: 70,
    studyYears: 2, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['desk', 'creative'],
  },
  "Vet": {
    analytical: 80, creative: 30, social: 70, physical: 60,
    structure: 70, risk: 60, income: 70,
    studyYears: 5.5, riskLevel: 'medium', pressureLevel: 'high',
    rejectionTags: ['healthcare'],
  },
  "Video Editor": {
    analytical: 40, creative: 90, social: 40, physical: 20,
    structure: 30, risk: 70, income: 60,
    studyYears: 1.5, riskLevel: 'high', pressureLevel: 'medium',
    rejectionTags: ['desk', 'creative'],
  },
  "Welder": {
    analytical: 50, creative: 60, social: 20, physical: 90,
    structure: 80, risk: 40, income: 50,
    studyYears: 2, riskLevel: 'medium', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
  "Welder / Fabricator": {
    analytical: 60, creative: 50, social: 20, physical: 80,
    structure: 70, risk: 30, income: 50,
    studyYears: 2, riskLevel: 'low', pressureLevel: 'medium',
    rejectionTags: ['manual'],
  },
};

export function getCareerMeta(name: string): CareerMeta {
  return CAREER_META[name] ?? {
    analytical: 50, creative: 50, social: 50, physical: 50,
    structure: 50, risk: 50, income: 50,
    studyYears: 2, riskLevel: 'medium', pressureLevel: 'medium', rejectionTags: [],
  };
}